import { createSlice } from '@reduxjs/toolkit'

export const RolePermissionSlice = createSlice(
  {
  name: 'role_permission',
  initialState: {
    value: '',
  },
  reducers: {
    rolePermissionSelected: (state, action) => {
      state.value = action.payload
    },
  },
})
export const { rolePermissionSelected } = RolePermissionSlice.actions

export default RolePermissionSlice.reducer